export var guardLeadingZero = function guardLeadingZero(value) {
  return value.replace(/^0(?![,.][\d]*$)(?!$)/, '');
};